// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://f047cdee1b33c90dae5a92e4bde0f46a@o4510002695372800.ingest.us.sentry.io/4510046507499520',

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
      maskAllText: false,
    }),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 0.1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.0,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

(function () {
  // capture original JSON parse
  const originalParse = JSON.parse;

  // Replace parse behavior
  JSON.parse = function (text, reviver) {
    // Add your custom interception logic here
    //console.debug("Intercepted JSON.parse call with text:", text);

    // You can modify the 'text' or 'reviver' before calling the original parse
    // For example, to handle specific string replacements or data transformations

    try {
      const result = originalParse(text, reviver);
      // You can also add post-processing logic here on the 'result'
      //console.debug("JSON.parse successful, result:", result);
      return result;
    } catch (error) {
      console.error('Failed to parse source JSON: ', error, text);
      return null;
    }
  };
})();
